import React, { useState, useEffect, useCallback } from 'react';
import DataTable from 'datatables.net-react';
import DT from 'datatables.net-bs5';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import 'datatables.net-responsive-bs5/css/responsive.bootstrap5.min.css';
import 'flag-icons/css/flag-icons.min.css';
import '../../../styles/Datatable.scss';
import { API_URL } from '../../../config';
import { getCountryCode } from '../../../utils/countryFlags';

DataTable.use(DT);

const DatatableRecherche = ({recherche, users}) => {
  const [tableData, setTableData] = useState([]);
  const [cityCountryMap, setCityCountryMap] = useState({});

  // Récupérer les villes pour construire le mapping ville → pays
  useEffect(() => {
    fetch(`${API_URL}/api/city/getcities`)
      .then(res => res.json())
      .then((result) => {
        if (result.status === 0 && result.cities) {
          const map = {};
          result.cities.forEach(city => {
            if (city.name && city.country) {
              map[city.name] = city.country;
            }
          });
          setCityCountryMap(map);
        }
      })
      .catch(() => {});
  }, []);

  const transformData = useCallback((data, usersData, cityMap) => {
    if (!data) return [];

    const findObjectById = (array, id) => {
      return array.find(item => item._id === id) || null;
    };

    return data.map((item) => {
        const formatDate = (dateString) => {
          const date = new Date(dateString);
          const day = String(date.getDate()).padStart(2, '0');
          const month = String(date.getMonth() + 1).padStart(2, '0');
          const year = date.getFullYear();
          return `${day}/${month}/${year}`;
        };

        const currentUser = findObjectById(usersData, item.userId)

        const startCountry = cityMap[item.startCity] || item.startCity || '';
        const endCountry = cityMap[item.endCity] || item.endCity || '';
        const startIso = getCountryCode(startCountry);
        const endIso = getCountryCode(endCountry);

        return [
          item.status === 'container' ? 'Conteneur' : 'Kilo',
          item.startCity,
          item.endCity,
          item.month+'/'+item.year,
          formatDate(item.date),
          currentUser?.name || '',
          currentUser?.email || '',
          new Date(item.date).getTime(),
          startIso || '',
          endIso || '',
        ];
    }).sort((a, b) => b[7] - a[7]);
  }, []);

  useEffect(() => {
    if (recherche && users && Object.keys(cityCountryMap).length > 0) {
      setTableData(transformData(recherche, users, cityCountryMap));
    }
  }, [recherche, users, cityCountryMap, transformData]);

  const renderCityWithFlag = (data, type, row, meta) => {
    if (type !== 'display') return data;
    const isoIndex = meta.col === 1 ? 8 : 9;
    const iso = row[isoIndex];
    if (iso) {
      return `<span class="fi fi-${iso}" style="margin-right:6px"></span>${data}`;
    }
    return data;
  };

  const columns = [
    { title: 'Type', data: 0 },
    { title: 'Départ', data: 1, render: renderCityWithFlag },
    { title: 'Arrivée', data: 2, render: renderCityWithFlag },
    { title: 'Départ le', data: 3 },
    { title: 'Créé le', data: 4 },
    { title: 'Poster par', data: 5 },
  ];

  const options = {
    order: [[7, 'desc']],
    language: {
      processing: 'Traitement en cours...',
      search: 'Rechercher&nbsp;:',
      lengthMenu: 'Afficher _MENU_ éléments',
      info: "Affichage de l'élément _START_ à _END_ sur _TOTAL_ éléments",
      infoEmpty: "Affichage de l'élément 0 à 0 sur 0 éléments",
      infoFiltered: '(filtré de _MAX_ éléments au total)',
      loadingRecords: 'Chargement en cours...',
      zeroRecords: 'Aucun élément à afficher',
      emptyTable: 'Aucune donnée disponible dans le tableau',
      paginate: {
        first: 'Premier',
        previous: 'Précédent',
        next: 'Suivant',
        last: 'Dernier',
      },
    },
  };

  return (
    <>
      <DataTable
        data={tableData}
        columns={columns}
        options={options}
        className="table table-striped"
        style={{ width: '100%' }}
      />
    </>
  );
};

export default DatatableRecherche;
